import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ServerTable from "../../components/atoms/tables/serverTable";
import { MagnifyingGlassIcon, EyeIcon, PencilSquareIcon, TrashIcon, SpeakerWaveIcon } from "@heroicons/react/24/outline";
import { debounce } from "lodash";
import Loader from "../../components/atoms/loader";
import Axios from "../../AxiosConfig";
import { useStore } from "../../store";
import swal from 'sweetalert';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const PastEmployees = ({
    hardFilters = {}
}) => {
    const navigate = useNavigate();
    const { layoutStore, employeeStore } = useStore();
    const columns = [
        {
            name: "Image",
            selector: "imageProfile",
            sortable: false,
            sortField: "imageProfile",
            cell: (row) => (
                <div className="flex justify-center h-16 w-16 py-1">
                    <img src={row.imageProfile || "/avatar.png"} alt="imageProfile" className="rounded-lg" />
                </div>
            )
        },
        {
            name: "Name",
            sortable: true,
            selector: "name",
            sortField: "name",
            cell: (row) => (
                <span className="cursor-pointer underline" onClick={() => { navigate(`/past-employees/${row.uuid}`) }}>
                    {row.name}
                </span>
            )
        },
        {
            name: "Designation",
            selector: "designation",
            sortable: true,
            sortField: "designation",
        },
        {
            name: "Department",
            selector: "department",
            sortable: true,
            sortField: "department",
        },
        {
            name: "Email",
            selector: "email",
            sortable: true,
            sortField: "email",
        },
        {
            name: "Phone",
            selector: "phone"
        },
        {
            name: "Actions",
            cell: (row) => (
                <div className="flex justify-end">
                    <button
                        className="text-gray-600 hover:text-gray-900 font-semibold rounded-full hover:bg-gray-500 hover:text-white p-1"
                        onClick={() => navigate(`/past-employees/${row.uuid}`) }
                    >
                        <EyeIcon className="h-5 w-5" />
                    </button>
                    {/* <button
                        className="text-blue-600 hover:text-white font-semibold ml-1 rounded-full hover:bg-blue-500 hover:text-white p-1"
                        onClick={() => { navigate(`/past-employees/edit/${row.uuid}`) }}
                    >
                        <PencilSquareIcon className="h-5 w-5" />
                    </button> */}
                    {/* <button
                        className="text-red-600 hover:text-red-900 ml-1 font-semibold rounded-full hover:bg-red-500 hover:text-white p-1"
                        // popup confirm
                        onClick={() => {
                            swal({
                                text: "Are you sure you want to delete this employee and all the associated data?",
                                icon: "warning",
                                buttons: true,
                                dangerMode: true,
                            })
                                .then((willDelete) => {
                                    if (willDelete) {
                                        employeeStore.deleteEmployee(row.uuid).then((res) => {
                                            if (res.error) {
                                                layoutStore.showToaster(res.error, "error");
                                                return;
                                            }
                                            layoutStore.showToaster("Employee Deleted", "success");
                                            // reload page
                                            setTimeout(() => {
                                                window.location.reload();
                                            }, 1000);
                                        });
                                    }
                                });
                        }}
                    >
                        <TrashIcon className="h-5 w-5" />
                    </button> */}
                </div>
            )
        }
    ];
    const [query, setQuery] = useState("");
    const [filters, setFilters] = useState({});
    const [loading, setLoading] = useState(false);
    const [reportUrl, setReportUrl] = useState(null);
    useEffect(() => {
        if (query.length > 0) {
            debounce(() => {
                setFilters({ query, ...hardFilters });
            }, 500)();
        }
        else {
            debounce(() => {
                setFilters({ ...hardFilters });
            }, 500)();
        }
    }, [query]);

    const downloadReport = () => {
        setLoading(true);
        Axios.post("/reports/employees", { filters: filters, 'past': 1 }).then((res) => {
            if (res.data.success) {
                setReportUrl(res.data.url);
                window.open(res.data.url, "_blank");
            }
            else {
                layoutStore.showToaster(res.data.error, "error")
            }
            setLoading(false);
        });

    };
    return (
        <>
            {loading && <Loader />}
            {
                reportUrl &&
                <div className="rounded-md bg-blue-50 p-4 mb-4">
                    <div className="flex">
                        <div className="ml-3 flex-1 md:flex md:justify-between">
                            <p className="text-sm text-blue-700">
                                If the download didn't start automatically, download the report by clicking the link 👉.
                            </p>
                            <p className="mt-3 text-sm md:mt-0 md:ml-6">
                                <a href={reportUrl}
                                    target="_blank"
                                    className="whitespace-nowrap font-medium text-blue-700 hover:text-blue-600">
                                    Download Report
                                    <span aria-hidden="true"> &rarr;</span>
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            }
            <div className="text-right">
                <div className="mt-1 flex rounded-md shadow-sm">
                    <div className="relative mr-px flex flex-grow items-stretch focus-within:z-10">
                        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                            <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                        </div>
                        <input
                            type="search"
                            name="search"
                            onChange={(e) => setQuery(e.target.value)}
                            className={`block w-full ${Object.entries(hardFilters).length == 0 ? "rounded-md" : "rounded-md"} border-gray-300 hover:border-blue-500 pl-10 focus:border-blue-500 focus:ring-blue-500 sm:text-sm`}
                            placeholder="Search By Name, Department, Designation, Email, Phone"
                        />
                    </div>

                    <span className="isolate inline-flex rounded-md shadow-sm">
                        <button
                            type="button"
                            onClick={downloadReport}
                            className="inline-flex items-center rounded-r-md border-white bg-blue-600 px-4 py-2 mx-px text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                        >
                            Export Data
                        </button>
                    </span>

                </div>
            </div>
            <div className='mt-4'>
                <ServerTable
                    key={JSON.stringify(filters)}
                    apiURL={'/employee/get-past-employee'}
                    columns={columns}
                    filters={filters}
                />
            </div>

        </>
    );
};
export default PastEmployees;